import React from 'react';
import ReactDOM from 'react-dom';
import TextCell from './TextCell';
import SortHeaderCell from './SortHeaderCell';
import { Table, Column, Cell } from 'fixed-data-table';
import * as actions from '../redux/actions';
import DataTableUtil from '../DataTableUtil';
import Storage from '../Storage';
import { SortTypes } from '../Constants';
import KioskVersionSet from '../model/KioskVersionSet';
import BaseLayout from './pages/BaseLayout';
import { browserHistory } from 'react-router';

const DEFAULT_COL_SORT_DIRS = { lastUpdated: SortTypes.DESC };
const DEFAULT_TABLE_WIDTH = 1276;
const DEFAULT_TABLE_HEIGHT = 500;

function getFilterKey(tableTitle, tableView) {
  return tableTitle + '-' + tableView + '-filterText';
}

function getColSortKey(tableTitle, tableView) {
  return tableTitle + '-' + tableView + '-columnSortDirs';
}

function getTableViewKey() {
  return 'KioskDeploymentSetTable : tableView';
}

const LIST_VIEW = 'list';
const HISTORY_VIEW = 'change history';

const FILTER_COLUMNS = {
  [LIST_VIEW]: [
    'name',
    'printapi',
    'payapi',
    'capui',
    'kskapi',
    'heatwave',
    'linuxdash',
    'kioskprobe',
    'ciscoamp',
    'reason',
    'lastUpdatedDateTime',
    'lastUpdatedXAgo',
    'updatedBy',
  ],
  [HISTORY_VIEW]: [
    'actionType',
    'name',
    'printapi',
    'payapi',
    'capui',
    'kskapi',
    'heatwave',
    'linuxdash',
    'kioskprobe',
    'ciscoamp',
    'reason',
    'lastUpdatedDateTime',
    'lastUpdatedXAgo',
    'updatedBy',
  ],
};

class KioskDeploymentSetTable extends React.Component {
  constructor(props) {
    super(props);

    let tableView = Storage.getSessionItem(getTableViewKey()) || LIST_VIEW;
    let filterText = Storage.getSessionItem(getFilterKey(props.tableTitle, tableView)) || '';
    let columnSortDirs =
      Storage.getSessionItem(getColSortKey(props.tableTitle, tableView)) || DEFAULT_COL_SORT_DIRS;

    this.state = {
      tableView: tableView,
      filterText: filterText,
      columnSortDirs: columnSortDirs,
    };

    this.handleSortChange = this.handleSortChange.bind(this);
    this.handleFilter = this.handleFilter.bind(this);
    this.handleShowCreatePage = this.handleShowCreatePage.bind(this);
    this.handleShowEditPage = this.handleShowEditPage.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(actions.getKVSList());
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  handleSortChange(columnKey, sortDir) {
    let value = { [columnKey]: sortDir };
    this.setState({ columnSortDirs: value }, () => {
      Storage.setSessionItem(getColSortKey(this.props.tableTitle, this.state.tableView), value);
    });
  }

  handleFilter(e) {
    if (!e.target.value) {
      this.setState({ filterText: '' }, () => {
        Storage.setSessionItem(getFilterKey(this.props.tableTitle, this.state.tableView), '');
      });
      return;
    }

    const filterBy = this.refs.filterInput.value.toLowerCase();
    this.setState({ filterText: filterBy }, () => {
      Storage.setSessionItem(getFilterKey(this.props.tableTitle, this.state.tableView), filterBy);
    });
  }

  handleShowCreatePage() {
    let {auth: {user}} = this.props;
    if (user.isSuperRole()) {
      browserHistory.push('/kiosk/deployment/set/create');
    }
  }

  handleShowEditPage(kvs) {
    let {auth: {user}} = this.props;
    if (user.isSuperRole()) {
      browserHistory.push('/kiosk/deployment/set/edit/' + kvs.name);
    }
  }

  handleSelectTableView(tableView) {
    let filterText = Storage.getSessionItem(getFilterKey(this.props.tableTitle, tableView)) || '';
    let columnSortDirs =
      Storage.getSessionItem(getColSortKey(this.props.tableTitle, tableView)) ||
      DEFAULT_COL_SORT_DIRS;
    this.setState(
      {
        tableView: tableView,
        filterText: filterText, // also restore filter text
        columnSortDirs: columnSortDirs, // also restore column sort directions
      },
      () => {
        Storage.setSessionItem(getTableViewKey(), tableView);
      }
    );
  }

  handleRowClick(dataList, event, rowIndex) {
    let name = dataList[rowIndex].name;
  }

  handleMainColumnClick(kvs) {
    if (this.state.tableView === HISTORY_VIEW) {
      return;
    }
    this.handleShowEditPage(kvs);
  }

  render() {
    const { filterText, columnSortDirs, tableView } = this.state;
    let kvsList = this.props.kvsList || [];
    let isHistoryView = tableView === HISTORY_VIEW;
    if (isHistoryView) {
      kvsList = this.props.kvsHistoryList || [];
    }

    const dataList = DataTableUtil.filterList(
      kvsList,
      filterText,
      FILTER_COLUMNS[tableView],
      columnSortDirs
    );
    const size = kvsList.length;

    // console.log(this.props.tableTitle + ' render: ' + new Date().toLocaleString());
    let tableWidth = this.props.tableWidth || DEFAULT_TABLE_WIDTH;
    let tableHeight = BaseLayout.calcTableHeight(dataList) || DEFAULT_TABLE_HEIGHT;

    let {auth: {user}} = this.props;
    let isSuper = user.isSuperRole();

    return (
      <div>
        <div style={{ display: 'block', margin: '20px auto', width: tableWidth }}>
          <div className='pure-g pure-u-1 card-label button-tetriary'>
            {isSuper && (
              <div style={{ position: 'absolute', top: 0, left: 0 }}>
                <button
                  className='pure-button button-title button-tetriary'
                  onClick={this.handleShowCreatePage}
                >
                  <i className='fa fa-fw fa-plus' />
                </button>
              </div>
            )}

            <div className='button-title' style={{ position: 'absolute', top: 0, left: 70 }}>
              <a
                className={tableView === LIST_VIEW ? 'tableview tableview-selected' : 'tableview'}
                onClick={this.handleSelectTableView.bind(this, LIST_VIEW)}
              >
                {LIST_VIEW}
              </a>
              <a
                className={
                  tableView === HISTORY_VIEW ? 'tableview tableview-selected' : 'tableview'
                }
                onClick={this.handleSelectTableView.bind(this, HISTORY_VIEW)}
              >
                {HISTORY_VIEW}
              </a>
            </div>

            <i className='fa fa-fw fa-desktop' />
            {this.props.tableTitle}
            <input
              className='table-search'
              type='search'
              placeholder='Search'
              ref='filterInput'
              value={filterText}
              onChange={this.handleFilter}
            />
          </div>

          <Table
            rowsCount={dataList.length}
            rowHeight={55}
            headerHeight={50}
            width={tableWidth}
            height={tableHeight}
            onRowClick={this.handleRowClick.bind(this, dataList)}
            {...this.props}
          >
            <Column
              header={<Cell>#</Cell>}
              cell={(props) => (
                <Cell {...props}>
                  <span style={{ fontSize: 10 }}>{props.rowIndex + 1}</span>
                </Cell>
              )}
              fixed={true}
              width={46}
              align='center'
            />
            {isHistoryView && (
              <Column
                columnKey='actionType'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.actionType}
                  >
                    Action Type
                  </SortHeaderCell>
                }
                cell={<TextCell dataList={dataList} field='actionType' />}
                fixed={true}
                width={70}
              />
            )}
            <Column
              columnKey='name'
              header={
                <SortHeaderCell onSortChange={this.handleSortChange} sortDir={columnSortDirs.name}>
                  Name
                </SortHeaderCell>
              }
              cell={(props) => (
                <Cell
                  {...props}
                  style={isHistoryView ? {} : { cursor: 'pointer', color: 'blue' }}
                  onClick={this.handleMainColumnClick.bind(this, dataList[props.rowIndex])}
                >
                  <span style={{ fontWeight: 600 }}>{dataList[props.rowIndex].name}</span>
                </Cell>
              )}
              fixed={true}
              width={110}
            />
            <Column
              columnKey='printapi'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.printapi}
                >
                  printapi
                </SortHeaderCell>
              }
              cell={<TextCell dataList={dataList} field='printapi' />}
              fixed={true}
              width={80}
            />
            <Column
              columnKey='payapi'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.payapi}
                >
                  payapi
                </SortHeaderCell>
              }
              cell={<TextCell dataList={dataList} field='payapi' />}
              fixed={true}
              width={80}
            />
            <Column
              columnKey='capui'
              header={
                <SortHeaderCell onSortChange={this.handleSortChange} sortDir={columnSortDirs.capui}>
                  capui
                </SortHeaderCell>
              }
              cell={<TextCell dataList={dataList} field='capui' />}
              fixed={true}
              width={80}
            />
            <Column
              columnKey='kioskprobe'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.kioskprobe}
                >
                  kiosk-probe
                </SortHeaderCell>
              }
              cell={<TextCell dataList={dataList} field='kioskprobe' />}
              fixed={true}
              width={80}
            />
            <Column
              columnKey='kskapi'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.kskapi}
                >
                  kskapi
                </SortHeaderCell>
              }
              cell={<TextCell dataList={dataList} field='kskapi' />}
              fixed={true}
              width={80}
            />
            <Column
              columnKey='cafeapi'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.cafeapi}
                >
                  cafeapi
                </SortHeaderCell>
              }
              cell={<TextCell dataList={dataList} field='cafeapi' />}
              fixed={true}
              width={80}
            />
            <Column
              columnKey='heatwave'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.heatwave}
                >
                  heatwave
                </SortHeaderCell>
              }
              cell={<TextCell dataList={dataList} field='heatwave' />}
              fixed={true}
              width={80}
            />
            <Column
              columnKey='linuxdash'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.linuxdash}
                >
                  linuxdash
                </SortHeaderCell>
              }
              cell={<TextCell dataList={dataList} field='linuxdash' />}
              fixed={true}
              width={80}
            />
            <Column
              columnKey='ciscoampVersion'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.ciscoampVersion}
                >
                  cisco-amp
                </SortHeaderCell>
              }
              cell={<TextCell dataList={dataList} field='ciscoamp' />}
              fixed={true}
              width={80}
            />
            <Column
              columnKey='reason'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.description}
                >
                  Update Reason
                </SortHeaderCell>
              }
              cell={<TextCell dataList={dataList} field='reason' />}
              fixed={true}
              width={isHistoryView ? 130 : 150}
            />
            <Column
              columnKey='updatedByName'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.updatedByName}
                >
                  Last Updated By
                </SortHeaderCell>
              }
              cell={
                <TextCell dataList={dataList} field='updatedByName' hoverTextField='updatedBy' />
              }
              fixed={true}
              width={isHistoryView ? 120 : 130}
            />
            <Column
              columnKey='lastUpdatedDateTime'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.lastUpdatedDateTime}
                >
                  Last Updated
                </SortHeaderCell>
              }
              cell={
                <TextCell
                  dataList={dataList}
                  field='lastUpdatedXAgo'
                  hoverTextField='lastUpdatedDateTime'
                />
              }
              fixed={true}
              width={100}
            />
          </Table>
          <div className='pure-g' style={{ padding: '5px 0' }}>
            <div className='pure-u-1-3'>
              {dataList.length < size ? (
                <span>
                  Showing {dataList.length} entries (filtered from {size} total entries)
                </span>
              ) : (
                <span>
                  Showing {dataList.length} of {size}
                </span>
              )}
            </div>
            <div className='pure-u-1-3'></div>
            <div className='pure-u-1-3' style={{ textAlign: 'right' }}></div>
          </div>
        </div>
      </div>
    );
  }
}

export default KioskDeploymentSetTable;



// WEBPACK FOOTER //
// ./src/components/KioskDeploymentSetTable.js